import React from "react"
import { useNavigate } from "react-router-dom";
import { useLocation } from 'react-router-dom';
import { useParams } from 'react-router-dom';
import { isNull, isEqual, isArray } from "lodash";

import {cloneObject, getParam, formatDate, formatText, truncate} from '../utils/utils';

import dsd from "../classes/clsDSD";

import * as PD from '../classes/pdStyle';

import { listEnumerations } from "../utils/utilsDataDictionary";

class ListEnumerations extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            renderState: 'loading',
            Enumerations : null
        };

        this.dsd = new dsd();

    }

componentDidMount(){

    this.setup();
 
}


componentDidUpdate(prevProps, prevState){

   if (!isEqual(this.props, prevProps)){
       this.setup();
   }

}

loadData(filters){

    const onLoad = function(arr){
        this.setState({
            Enumerations: arr,
            renderState: 'loaded'
        });
        
        // Call parent's onLoad callback if provided
        if (this.state.onLoad){
            this.state.onLoad(arr.length);
        }
    }.bind(this);

    const onError = function(e){
        this.setState({
            renderState: 'failed',
            errorMessage: e.message
        });
    }.bind(this);

    listEnumerations(this.dsd, filters, onLoad, onError);
}


setup(){

    let StateChange = {
        filters: {},
        columns: {
        },
        onLoad: null,
        renderState: 'loading'
    };

    if (getParam('filters', this.props)){
        StateChange.filters = getParam('filters', this.props);
    }

    if (getParam('columns', this.props)){
        StateChange.columns = getParam('columns', this.props);
    }

    if (getParam('onLoad', this.props)){
        StateChange.onLoad = getParam('onLoad', this.props);
    }

    this.setState(StateChange);

    this.loadData(StateChange.filters);
        
}



    included(Enumeration) {

        let IncludeThis = true;

        return IncludeThis;
    }

    render() {


        if (this.state.renderState === 'failed') {
            return (
                <PD.ErrorBox>
                    {this.state.errorMessage || 'A problem has occurred'}
                </PD.ErrorBox>
            )
        }


        if (this.state.renderState === 'loaded') {
            let arrEnumerations = this.state.Enumerations;
            if (isArray(arrEnumerations)){
                if (arrEnumerations.length > 0){

                    return (
                        <PD.Table className="list">
                            <PD.Thead>
                                <PD.Tr>
                                    <PD.Th>Name</PD.Th>
                                    <PD.Th>Description</PD.Th>
                                </PD.Tr>
                            </PD.Thead>

                            <PD.Tbody>

                            {
                                arrEnumerations.map(
                                    (Enumeration, pos) => 
                                    {
                                        if (this.included(Enumeration)) {

                                            let maxRows = 1;

                                            let Rows = []
                                            for (let i = 1; i <= maxRows; i++) {
                                                Rows.push(null);
                                            }
                
                                            return (

                                                <PD.Tr key={pos}>
                                                    <PD.Td>
                                                        <PD.PdNavLink to={"/enumeration/" + Enumeration._id} > {Enumeration.name}</PD.PdNavLink>
                                                    </PD.Td>
                                                    <PD.Td>
                                                        <PD.MdPresent>{truncate(Enumeration.description, 400)}</PD.MdPresent>
                                                    </PD.Td>
                                                </PD.Tr>

                                            )
                                        }
                                        else{
                                            return null;
                                        }                
                                    }
                                )
                            }
                            </PD.Tbody>

                        </PD.Table>
                    )
                }
            }
        }

        return <div />;

    };    
};
        
export default function ListEnumerations_wrapper(props) {
    
    const navigation = useNavigate();
    const location = useLocation();
    const params = useParams();

    return <ListEnumerations {...props} navigation={navigation} location={location} params={params} />;
  }
